import type { ComponentType } from 'react';
import MuiSvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import { iconColors } from '@/tokens/colors';

/**
 * Icon
 * Classification: mui-wrapper
 * MUI base: https://mui.com/material-ui/icons/
 *
 * Thin wrapper around MUI's SvgIcon that standardizes semantic icon colors via
 * design tokens. Pass any `@mui/icons-material` icon as `icon`.
 */

export type IconTone = keyof typeof iconColors;

export interface IconProps extends Omit<SvgIconProps, 'color'> {
  /** The icon component, e.g. from `@mui/icons-material`. */
  icon: ComponentType<SvgIconProps>;
  /** Semantic color from the icon token set. Defaults to `inherit`. */
  tone?: IconTone;
}

export function Icon({ icon: IconComponent, tone, sx, ...rest }: IconProps) {
  return (
    <IconComponent
      sx={{ color: tone ? iconColors[tone] : 'inherit', ...sx }}
      {...rest}
    />
  );
}

/** Re-export SvgIcon for building fully-custom icons. */
export { MuiSvgIcon as SvgIcon };
export type { SvgIconProps };
